import { render, staticRenderFns } from "./PreLoading.vue?vue&type=template&id=bed78bd6"
import script from "./PreLoading.vue?vue&type=script&lang=ts"
export * from "./PreLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports